import BreadCrumb from "../components/BreadCrumb/breadCrumb";
import Testimonials from "../components/Testimonials";
import WhoWeAre from "../components/WhoWeAre/WhoWeAre";

export default function AboutUsPage(){
    return (
        <>
        <BreadCrumb id="about-us" desc="We transform the technology services etiquette globally." title="How We Are Diffrent ?"/>
        <WhoWeAre/>
        <Testimonials/>
    </>
    )
}